/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, createContext, forwardRef } from 'react';
import { CalendarGridHeader as CalendarGridHeaderCore, type CalendarGridHeaderProps as CalendarGridHeaderCoreProps, type ContextValue, useContextProps } from 'react-aria-components';

interface CalendarGridHeaderProps extends Omit<CalendarGridHeaderCoreProps, 'style' | 'className'> {
  style?: stylex.StyleXStyles;
}

const CalendarGridHeaderContext = createContext<ContextValue<CalendarGridHeaderProps, HTMLTableSectionElement>>({});

const CalendarGridHeader = forwardRef((props: CalendarGridHeaderProps, ref: ForwardedRef<HTMLTableSectionElement>) => {
  // @ts-expect-error - CalendarGridHeaderCoreProps is not typed correctly
  [props, ref] = useContextProps(props, ref, CalendarGridHeaderContext);

  const { style, children, ...coreProps } = props;

  return (
    <CalendarGridHeaderCore ref={ref} {...stylex.props(styles.base, style)} {...coreProps}>
      {(day) => {
        const formattedDay = day.length === 3
          ? shortWeekdayMap[day as keyof typeof shortWeekdayMap] || day
          : longWeekdayMap[day as keyof typeof longWeekdayMap] || day;

        const evaluatedChildren = typeof children === 'function' ? children(formattedDay) : children;

        return (
          <>
            {evaluatedChildren}
          </>
        );
      }}
    </CalendarGridHeaderCore>
  );
});

const shortWeekdayMap = {
  'Sun': 'Su',
  'Mon': 'Mo',
  'Tue': 'Tu',
  'Wed': 'We',
  'Thu': 'Th',
  'Fri': 'Fr',
  'Sat': 'Sa',
};

const longWeekdayMap = {
  'Sunday': 'Sun',
  'Monday': 'Mon',
  'Tuesday': 'Tue',
  'Wednesday': 'Wed',
  'Thursday': 'Thu',
  'Friday': 'Fri',
  'Saturday': 'Sat',
};

const styles = stylex.create({
  base: {
    borderCollapse: 'collapse',
    borderSpacing: 0,
  },
});

export { CalendarGridHeader, CalendarGridHeaderContext, type CalendarGridHeaderProps };
